(ns manatee.components.part
  (:require
   [clojure.string :as string]
   [manatee.admin.task-config.subs :as task-config-subs]
   [manatee.annotation.components :as annotation-components]
   [manatee.annotation.handlers :as handlers]
   [manatee.components.question-text :as question-text]
   [manatee.domain.item :as item]
   [manatee.domain.task :as task]
   [manatee.user.components :as user-components]
   [medley.core :refer [find-first]]
   [re-frame.core :as rf]
   [rothko.button.component :refer [button]]
   [rothko.form2.component :as f]
   [rothko.form2.select.core :as select]
   [rothko.form2.select.single-select.component :as single-select]
   [rothko.form2.validation :as validation]
   [rothko.panel.component :refer [panel]]))

(defn status-selector
  [{:keys [status]} feedback]
  (cond
    (#{:rejected :rejected-requires-approval} status) :rejected
    feedback (or (:status feedback) :under-review)
    ;; hide "requires approval" status from annotators, show as done
    (#{:requires-approval :rejected-requires-approval} status) :done
    :else status))

(defn status
  [{:keys [reason other-reason] :as item} feedback no-status-adjective task-config]
  (let [status* (status-selector item feedback)
        answer-rejection-options (get-in task-config [:data :answer :rejections :reasons])
        display-reason (when reason
                         (->> reason
                              (map (fn [reason-kw]
                                     (case reason-kw
                                       :other other-reason
                                       (:label (find-first #(= reason-kw (:value %))
                                                           answer-rejection-options)))))
                              (remove string/blank?)
                              (sort)
                              (string/join ", ")))]
    [:div.annotation__status
     [:h5 "Status :"]
     [:p {:class status*}
      (str (or (some-> status* name string/capitalize)
               no-status-adjective)
           (when reason (str " - " display-reason)))]]))

(defn previous-annotation-info
  [previous-annotations]
  (into [:<>]
        (for [{:keys [task-config-id user data]} previous-annotations
              :let [task-config @(rf/subscribe [::task-config-subs/task-config task-config-id])]]
          (if (task/scoring? task-config)
            [:p [:strong (user-components/full-name user)] " previously gave this part a score of " [:strong (or (:score data) (:cefr-level data))]]
            [:p [:strong (user-components/full-name user)] " previously transcribed this part"]))))

(defn previous-stage-annotations
  [previous-annotations]
  [:<>
   (doall (for [{:keys [task-config-id user cefr-level score user-id item-group-id]} (->> previous-annotations
                                                                                          (group-by :task-config-id)
                                                                                          vals
                                                                                          (map first))]
            (let [previous-part-link [:a {:href     "#"
                                          :on-click #(rf/dispatch [:navigate-to
                                                                   [:manatee.qa.handlers/item-group
                                                                    {:user-id       user-id
                                                                     :item-group-id item-group-id}]])}
                                      (str item-group-id)]
                  task-config        @(rf/subscribe [::task-config-subs/task-config task-config-id])]
              ^{:key (str item-group-id)} [:p [:strong (user-components/full-name user)]
                                           (if (task/scoring? task-config)
                                             [:<> " previously gave this part (" previous-part-link ") a score of " [:strong (or cefr-level score)]]
                                             [:<> " previously transcribed this part (" previous-part-link ")."])])))])

(defn part-panel
  [{:keys [answers class edits task-config]
    {:keys [feedback? task-documents] {:keys [rubric short-rubric]} :part :as item} :item}
   & children]
  (-> [panel (cond-> {:appearance #{:primary}}
               class (assoc :class class))
       (when (seq task-documents)
         (annotation-components/info-links task-documents (:id task-config)))
       [:h4 (item/part-label (get-in item [:part :number])
                             (task/task-config->part-description task-config (get-in item [:part :number])))]
       (let [long-rubric? (and rubric (task/modifier task-config :show-long-rubric?))
             short-rubric? (task/modifier task-config :show-short-rubric?)]
         (cond long-rubric? [:div.default-style-in-markdown (question-text/with-markdown rubric)]
               short-rubric? [:p short-rubric]))
       (when feedback?
         [:h5.feedback__warning "[Feedback available]"])
       (when (:previous-annotations item)
         [previous-annotation-info (:previous-annotations item)])]
      (into (for [{:keys [id feedback question]} answers]
              [:div
               [status (get edits id) feedback "To do" task-config]
               [button {:appearance #{:secondary :full-width}
                        :class #{:tab-item}
                        :on-click #(rf/dispatch [::handlers/set-current-item id])}
                [:div.answer-item-preview (question-text/with-markdown (:text question))]]]))
      (into children)))

(defn score-selector
  [{:keys [answers unannotated-answers disabled? score-name placeholder options spec messages init-value item]}]
  [:div.annotation__score
   [f/form
    (annotation-components/form-settings item)
    {score-name
     (cond-> {:appearance #{:primary (if (<= (count options)
                                             (* (count answers)
                                                4))
                                       :open-above
                                       :open-below)}
              ::f/name score-name
              ::f/disabled? #(or disabled?
                                 (boolean unannotated-answers))
              ::f/initial-value init-value
              ::f/placeholder placeholder
              ::select/options options}
       spec (assoc ::validation/spec spec
                   ::validation/messages messages))}
    (fn [_ selection]
      [:form
       [single-select/field (get selection score-name)]])]])
